import React from 'react';
import { Field } from 'redux-form';
import { formatDecimal } from 'utils/formatter';
import { connect } from 'react-redux';
import UploadFile from '../UploadFile/UploadFile';
import styles from '../DetailForm.css';

// components
import ModalkuNewBusinessInfoForm from './ModalkuNewBusinessInfoForm';
import ModalkuNewPersonalInfoForm from './ModalkuNewPersonalInfoForm';
import { alphabeticalAndSomeChar, textAreaField } from '../utilsForm';

class ModalkuForm extends React.Component {
  render() {
    const {
      sendingRequest,
      businessStartsState,
      businessLocationsState,
      logo,
      preApprovedAmount,
      interestRate,
      duration,
      isMarried,
      lenderName,
      changeField,
      monthlyInstallment,
      onClickChange,
    } = this.props;
    return (
      <div className={styles.wrapper}>
        <div
          className={`col-md-12 ${styles['div-body']} spacer ${
            styles['no-padding']
          } ${styles['box-list']} ${styles['box-scroll']}`}
        >
          <div className={`col-md-12 ${styles['box-body']}`}>
            <table className="col-md-12 col-lg-12">
              <tr>
                <td className={`text-center`}>
                  <img width={64} src={logo} alt="logo" />
                </td>
                <td className={`text-center`}>
                  <p className={`${styles['lender-title']}`}>Lender</p>
                  <p className={`${styles['lender-sub-title']}`}>
                    {lenderName}
                  </p>
                </td>
                <td className={`text-center`}>
                  <p className={`${styles['lender-title']}`}>Loan Amount</p>
                  <p className={`${styles['lender-sub-title']}`}>
                    IDR {formatDecimal(preApprovedAmount)}
                  </p>
                </td>
                <td className={`text-center`}>
                  <p className={`${styles['lender-title']}`}>Rate p.a.</p>
                  <p className={`${styles['lender-sub-title']}`}>
                    {interestRate}%
                  </p>
                </td>
                <td className={`text-center`}>
                  <p className={`${styles['lender-title']}`}>Tenure</p>
                  <p className={`${styles['lender-sub-title']}`}>
                    {duration} months
                  </p>
                </td>
                <td className={`text-center`}>
                  <p className={`${styles['lender-title']}`}>
                    Monthly Instalment
                  </p>
                  <p className={`${styles['lender-sub-title']}`}>
                    IDR {formatDecimal(monthlyInstallment)}/month
                  </p>
                </td>
                <td className={`text-center`}>
                  <a onClick={onClickChange} className="btn btn-link">
                    Change
                  </a>
                </td>
              </tr>
            </table>
            <div className="col-md-12 col-lg-12">
              <hr />
              <p className={styles['float-right']}>
                <red>*</red>
                Required
              </p>
            </div>
          </div>

          <ModalkuNewPersonalInfoForm
            {...this.props}
            changeField={this.props.changeField}
            businessLocationsState={businessLocationsState}
          />

          <div className="col-md-12 col-lg-12">
            <hr />
          </div>

          <ModalkuNewBusinessInfoForm
            changeField={changeField}
            businessLocationsState={businessLocationsState}
            businessStartsState={businessStartsState}
          />

          <div className="col-md-12 col-lg-12">
            <hr />
          </div>

          <div className={`col-md-12 col-lg-12`}>
            <div className="col-md-3">
              <label className={`${styles['title-information']}`}>
                Your Reason for Having a loan
              </label>
            </div>
            <div className="col-md-9">
              <div className="form-group row">
                <label
                  htmlFor="inputEmail3"
                  className="col-sm-4 col-form-label"
                >
                  Reason
                  <red>*</red>
                  <br />
                  (max 255 characters)
                </label>
                <div className="col-sm-8">
                  <Field
                    component={textAreaField}
                    name="loan_purpose"
                    maxLength="255"
                    placeholder="Your Reason for Having a Loan"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                    className={`form-control ${styles['account-name']}`}
                    normalize={alphabeticalAndSomeChar()}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-12 col-lg-12">
            <hr />
          </div>
          {/* UPLOAD DOCUMENT */}
          <div className={`col-md-12 col-lg-12`}>
            <div className="col-md-3">
              <label className={`${styles['title-information']}`}>
                Required Document
              </label>
              <p>Please scan and upload following documents.</p>
              <p>
                Format file should be <b>jpg, png, jpeg or pdf</b>
              </p>
              <p>
                File size should be less than <b>2MB</b>
              </p>
            </div>
            <div className="col-md-9">
              <div className="form-group row">
                <label
                  htmlFor="ktp_file"
                  className={`col-sm-4 ${styles['upload-label']}`}
                >
                  KTP
                  <red>*</red>
                </label>
                <div className="col-sm-8">
                  <div
                    className={`${styles['float-right']} ${
                      styles['full-width']
                    }`}
                  >
                    <Field
                      type="file"
                      name="ktp_file"
                      component={UploadFile}
                      className={`${styles['form-control-file']}`}
                      allowPDF
                    />
                  </div>
                </div>
              </div>
              {isMarried && isMarried.toLowerCase() === 'married' && (
                <div className="form-group row">
                  <label
                    htmlFor="ktp_spouse_file"
                    className={`col-sm-4 ${styles['upload-label']}`}
                  >
                    KTP Pasangan
                  </label>
                  <div className="col-sm-8">
                    <div
                      className={`${styles['float-right']} ${
                        styles['full-width']
                      }`}
                    >
                      <Field
                        type="file"
                        name="ktp_spouse_file"
                        component={UploadFile}
                        className={`${styles['form-control-file']}`}
                        allowPDF
                      />
                    </div>
                  </div>
                </div>
              )}
              <div className="form-group row">
                <label
                  htmlFor="npwp_file"
                  className={`col-sm-4 ${styles['upload-label']}`}
                >
                  NPWP
                  <red>*</red>
                </label>
                <div className="col-sm-8">
                  <div
                    className={`${styles['float-right']} ${
                      styles['full-width']
                    }`}
                  >
                    <Field
                      type="file"
                      name="npwp_file"
                      component={UploadFile}
                      className={`${styles['form-control-file']}`}
                      allowPDF
                    />
                  </div>
                </div>
              </div>

              <div className="form-group row">
                <label
                  htmlFor="siup_file"
                  className={`col-sm-4 ${styles['upload-label']}`}
                >
                  SIUP
                </label>
                <div className="col-sm-8">
                  <div
                    className={`${styles['float-right']} ${
                      styles['full-width']
                    }`}
                  >
                    <Field
                      type="file"
                      name="siup_file"
                      component={UploadFile}
                      className={`${styles['form-control-file']}`}
                      allowPDF
                    />
                  </div>
                </div>
              </div>

              <div className="form-group row">
                <label
                  htmlFor="outlet_picture_file"
                  className={`col-sm-4 ${styles['upload-label']}`}
                >
                  Outlet Picture
                </label>
                <div className="col-sm-8">
                  <div
                    className={`${styles['float-right']} ${
                      styles['full-width']
                    }`}
                  >
                    <Field
                      type="file"
                      name="outlet_picture_file"
                      component={UploadFile}
                      className={`${styles['form-control-file']}`}
                      allowPDF
                    />
                  </div>
                </div>
              </div>

              {preApprovedAmount > 100000000 && (
                <div>
                  <div className="form-group row">
                    <label
                      htmlFor="bank_statement_1_file"
                      className={`col-sm-4 ${styles['upload-label']}`}
                    >
                      Bank Statement 1<red>*</red>
                    </label>
                    <div className="col-sm-8">
                      <div
                        className={`${styles['float-right']} ${
                          styles['full-width']
                        }`}
                      >
                        <Field
                          type="file"
                          name="bank_statement_1_file"
                          component={UploadFile}
                          className={`${styles['form-control-file']}`}
                          allowPDF
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="bank_statement_2_file"
                      className={`col-sm-4 ${styles['upload-label']}`}
                    >
                      Bank Statement 2<red>*</red>
                    </label>
                    <div className="col-sm-8">
                      <div
                        className={`${styles['float-right']} ${
                          styles['full-width']
                        }`}
                      >
                        <Field
                          type="file"
                          name="bank_statement_2_file"
                          component={UploadFile}
                          className={`${styles['form-control-file']}`}
                          allowPDF
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="bank_statement_3_file"
                      className={`col-sm-4 ${styles['upload-label']}`}
                    >
                      Bank Statement 3<red>*</red>
                    </label>
                    <div className="col-sm-8">
                      <div
                        className={`${styles['float-right']} ${
                          styles['full-width']
                        }`}
                      >
                        <Field
                          type="file"
                          name="bank_statement_3_file"
                          component={UploadFile}
                          className={`${styles['form-control-file']}`}
                          allowPDF
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="col-md-12 col-lg-12">
              <p className={styles['float-right']}>
                <red>*</red>
                Required
              </p>
              <br />
              <hr />
              <button
                className={`btn ${styles['btn-upload-green']} `}
                disabled={sendingRequest}
                type="submit"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(ModalkuForm);
